import {
  Component,
  OnInit,
  ViewChild,
  TemplateRef,
  ViewEncapsulation,
  Input,
  Output,
  EventEmitter,
  OnDestroy
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { LoadInformationExcelDataService } from './shared/load-information-excel.data.service';

@Component({
  selector: 'iw-load-information-excel',
  templateUrl: './load-information-excel.component.html',
  styleUrls: ['./load-information-excel.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [LoadInformationExcelDataService]
})
export class LoadInformationExcelComponent implements OnInit, OnDestroy {

  // Contiene el id a donde se subira la informacion
  @Input() id: number;
  // Define el tipo de carga de informacion
  @Input() typeCharge: 'task' | 'master';
  // Contiene el id de la tarea a cargar la informacion
  @Input() btnClass: string;
  // Contiene el id de la tarea a cargar la informacion
  @Input() btnText: string;
  // Define la finaliacioncion de la tarea
  @Input() finishTask = false;
  // Contiene el id de la tarea a cargar la informacion
  @Input() btnUpload = true;
  // Define la finaliacioncion de la tarea
  @Input() btnDowload = true;
  // Variable que valida los tipos de documentos que se pueden subir
  extensions: string[] = ['xlsx', 'xls'];
  // Label de las extensiones permitidas
  extensionsLabel = '';
  // objeto de documentos
  documentUpload = false;
  // formulario
  formData = new FormData();
  // Variable que contendrá el formulario.
  formLoadDoc: FormGroup = new FormGroup({
    cell: new FormControl('', [Validators.required])
  });
  // Referencia de la modal
  modalRef: BsModalRef;
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();
  // Referencia al template de la modal
  @ViewChild('template') private template: TemplateRef<any>;
  // Salida de finalizacion de carga de informacion para un refresh
  @Output() refresh: EventEmitter<boolean> = new EventEmitter();

  constructor(
    private toastr: ToastrService,
    private ltids: LoadInformationExcelDataService,
    private modalService: BsModalService,
  ) { }

  ngOnInit() {
    for (let i = 0; i < this.extensions.length; i++) {
      this.extensionsLabel += this.extensions[i];
      if (i !== (this.extensions.length - 1)) {
        this.extensionsLabel += ', ';
      }
    }
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }

  /**
   * Abrir modal para subir documento para cargar la informacion
   *
   * @memberof LoadInformationExcelComponent
   */
  openLoadInformaction() {
    this.modalRef = this.modalService.show(this.template, { class: 'modal-lg'});
  }

  /**
   * Cerrar el modal de subir documentos
   *
   * @memberof LoadInformationExcelComponent
   */
  closeLoadInformaction() {
    this.documentUpload = false;
    this.formLoadDoc.controls['cell'].reset();
    this.modalRef.hide();
  }

  /**
   * Controla las acciones en el componente de cargar documentos
   *
   * @param {*} data
   * @returns {*}
   * @memberof LoadInformationExcelComponent
   */
  onAction(data: any): any {
    if (data.action === 1) {
      this.onAdded(data);
    } else if (data.action === 0) {
      this.onRemoved();
    }
  }

  /**
   * Remueve el documento cargado
   *
   * @returns {*}
   * @memberof LoadInformationExcelComponent
   */
  onRemoved(): any {
    this.formData = new FormData();
    this.documentUpload = false;
  }

  /**
   * Cargar el documento seleccionado
   *
   * @param {*} data
   * @returns {*}
   * @memberof LoadInformationExcelComponent
   */
  onAdded(data: any): any {
    this.formData = new FormData();
    switch (this.typeCharge) {
      case 'master':
        this.formData.append('maestra', String(this.id));
        break;
      default:
        this.formData.append('tarea', String(this.id));
        break;
    }
    this.formData.append('file', data.file);
    this.documentUpload = true;
  }

  /**
   * Subir el documento al sistema
   *
   * @memberof LoadInformationExcelComponent
   */
  uploadDocument() {
    if (this.documentUpload && this.formLoadDoc.controls['cell'].valid) {
      this.formData.append('row', this.formLoadDoc.controls['cell'].value);
      this.refresh.emit(false);
      switch (this.typeCharge) {
        case 'master':
          this.ltids.uploadFileMaster(this.formData).subscribe(res => {
            if (res) {
              this.closeLoadInformaction();
            }
              this.refresh.emit(true);
          });
          break;
        default:
          this.ltids.uploadFileTask(this.formData).subscribe(res => {
            if (res) {
              this.closeLoadInformaction();
            }
              this.refresh.emit(true);
          });
          break;
      }
    } else {
      if (!this.formLoadDoc.controls['cell'].valid) {
        this.toastr.warning('Debe ingresar la fila del documento donde inicia la informacion a cargar.',
                            'Información incompleta');
      } else {
        this.toastr.warning('Debe cargar un documento.', 'Información incompleta');

      }
    }
  }

  /**
   * Descargar el informe de la informacion
   *
   * @memberof LoadInformationExcelComponent
   */
  dowloadDocument() {
    switch (this.typeCharge) {
      case 'master':
        this.ltids.dowloadFileMaster(this.id).subscribe((res: any) => {
          const a = document.createElement('a');
          a.target = '_blank';
          a.href = res.path;
          a.download = 'informe_maestra.xlsx';
          a.click();
          a.remove();
        });
        break;
      default:
        this.ltids.dowloadFileTask(this.id).subscribe((res: any) => {
          const a = document.createElement('a');
          a.target = '_blank';
          a.href = res.path;
          a.download = 'informe_tarea.xlsx';
          a.click();
          a.remove();
        });
        break;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/load-information-excel/load-information-excel.component.ts